import type { FetchProcessesResponseData } from 'gcs-common/clients/api/entities/processes/processes-api-helpers';
import { pad } from 'gcs-common/helper/paddedNumberHelper';
import CubeIcon from '../../img/cube_primary.svg?react';
import styles from './styles.module.scss';

interface ProcessDetailSmallProps {
  process: FetchProcessesResponseData[number];
}

const ProcessDetailSmall = (props: ProcessDetailSmallProps) => {
  const { process } = props;
  const { ProcessNumber: Pnumber, ProcessTypeDescription: TypeText, CustomerOrderText } = process;

  const formattedProcessNumber = `${Pnumber}-${pad(process.ProcessSuffix)}`;
  return (
    <div
      className={styles.process}
      data-testid={`process-detail-${formattedProcessNumber}`}
      data-testprocessnumber={formattedProcessNumber}
    >
      <CubeIcon className={styles.magicCubeSmallIcon} />
      <div>
        <div className={styles.processHeader}>{TypeText}</div>
        <div className={styles.processNumber}>{formattedProcessNumber}</div>
        <div className={styles.processDetail}>Auftragstext: {CustomerOrderText}</div>
      </div>
    </div>
  );
};

export default ProcessDetailSmall;
